import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache) {
  const _component_vab_app = _resolveComponent("vab-app");

  return _openBlock(), _createBlock(_component_vab_app);
}